import createElement from '../../utils/create_element';
import { PlayerEnvironment } from '../../player_environment';

export default class BlockerSignIn {
  constructor({ tech } = {}) {
    this._tech = tech;
  }

  tech() {
    return this._tech;
  }

  show() {
    this.tech().el().appendChild(this.getBlocker());
  }

  getBlocker() {
    const href = this.getHref();

    return createElement(`
      <div class="vp-blocker-sign-in">
        <div class="vp-blocker-sign-in-container">
          <div>
            <div class="vp-blocker-sign-in__description-text-top">Sign in untuk menonton video ini</div>
          </div>
          <div class="vp-blocker-sign-in__actions">
            <a class="vp-blocker-sign-in__actions-button" href=${href}>Sign In</a>
          </div>
        </div>
      </div>
    `);
  }

  getHref() {
    const pathname = PlayerEnvironment.pathname();
    const locationSearch = PlayerEnvironment.locationSearch();

    return `/users/login?user_return_to=${pathname}${locationSearch}`;
  }
}
